module.exports = __webpack_public_path__ + "static/media/VelocityTrend.e35b0b76.png";